<template>
  <div class="cert-banner">
    <picture class="cert-banner-picture">
      <source media="(max-width: 767px)" :srcset="images.img375" />
      <source media="(max-width: 1023px)" :srcset="images.img768" />
      <source media="(max-width: 1279px)" :srcset="images.img1024" />
      <source media="(max-width: 1439px)" :srcset="images.img1280" />
      <source media="(max-width: 1919px)" :srcset="images.img1440" />
      <img
        class="cert-banner-image"
        :src="images.img1920"
        alt="PowerPlate Certification"
      />
    </picture>
    <div class="cert-banner-text">
      <div class="cert-banner-title">
        PowerPlate<br>Certification
      </div>
    </div>
  </div>
</template>

<script>
import banner from '@/assets/img/certification/384-ProjectNetwork.Powerplate_02-HannahElizabeth.co.uk.jpg';

export default {
  name: 'CertificationBanner',
  data() {
    return {
      // One file on every breakpoint until cropped versions are added.
      images: {
        img375: banner,
        img768: banner,
        img1024: banner,
        img1280: banner,
        img1440: banner,
        img1920: banner,
      },
    };
  },
};
</script>

<style scoped>
.cert-banner {
  position: relative;
  width: 100%;
  height: 140vw;
  overflow: hidden;
}

@media screen and (min-width: 580px) {
  .cert-banner {
    height: 120vw;
  }
}

@media screen and (min-width: 768px) {
  .cert-banner {
    height: 70vw;
  }
}

@media screen and (min-width: 1180px) {
  .cert-banner {
    height: calc(100vh - 192px);
  }
}

.cert-banner-picture {
  display: block;
  width: 100%;
  height: 100%;
}

.cert-banner-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.cert-banner-text {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  padding: 40px 16px 0;
  color: white;
  text-align: left;
  box-sizing: border-box;
}

@media screen and (min-width: 768px) {
  .cert-banner-text {
    width: 50%;
    align-items: center;
    padding: 0 40px;
  }
}

@media screen and (min-width: 1440px) {
  .cert-banner-text {
    padding: 0 80px;
  }
}

@media screen and (min-width: 1920px) {
  .cert-banner-text {
    padding: 0 120px;
  }
}

.cert-banner-title {
  line-height: 1.05;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 32px;
}

@media screen and (min-width: 768px) {
  .cert-banner-title {
    font-size: 36px;
  }
}

@media screen and (min-width: 1024px) {
  .cert-banner-title {
    font-size: 60px;
  }
}

@media screen and (min-width: 1920px) {
  .cert-banner-title {
    font-size: 66px;
  }
}
</style>
